/* eslint-disable */
import materialUI from "material-UI";
import styled from "styled-components";
import color from "../../constants/color";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 110vh;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 32px 32px 32px;
  padding: 32px 24px 32px 32px;
  min-width: 700px;
  background: #fff;
  border-radius: 8px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;
export const ContainerPagination = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 30px;
  margin-left: 0px;
  margin-bottom: 20px;
  margin-right: 0px;
`;
export const Select = styled(materialUI.Select)`
  padding-left: 4px;
  margin-left: 10px;
  color: #46505a;
  border: 1px solid #c6ccd7;
  border-radius: 16px;
  height: 32px;

  legend {
    span {
      display: none;
    }
  }
`;
export const Arrow = styled.div`
  display: flex;
  width: 25px;
  justify-content: center;
  align-items: center;
  height: 25px;
  margin: 0px 4px 0px 4px;
  background-color: ${color.grey6};
  border-radius: 30px;
`;
export const Arrows = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  li {
    button {
      background: #f2f4f8;
      color: #819dff;
      border: none;
      width: 26px;
      height: 26px;
    }
    .Mui-selected {
      background-color: #819dff;
      color: #ffffff;
      border-radius: 3px;
    }
  }
`;

export const MenuItem = styled(materialUI.MenuItem)`
  font-family: Inter;
  font-size: 14px;
`;